class Device {
  id: string;
  timezone: string;
}

export default Device;
